import ConfigurationListingFilters from './Components/ConfigurationListingFilters/ConfigurationListingFilters';
import ConfigurationListingTableHeader from './Components/ConfigurationListingTableHeader/ConfigurationListingTableHeader';
import ConfigurationListingTableBody from './Components/ConfigurationListingTableBody/ConfigurationListingTableBody';
import { IConfigurationData } from '../../../../../../types/product.configuration.types';
import './ConfigurationList.scss';

const ConfigurationList = ({
  getOrganizationConfigByOrganizationIdData,
  isLoadingGetOrganizationConfigByOrganizationId,
  totalConfigurationCount
}: {
  getOrganizationConfigByOrganizationIdData: IConfigurationData[];
  isLoadingGetOrganizationConfigByOrganizationId: boolean;
  totalConfigurationCount: number;
}) => {
  return (
    <div className="configurationList">
      <ConfigurationListingFilters />
      <ConfigurationListingTableHeader />
      <ConfigurationListingTableBody
        configurations={getOrganizationConfigByOrganizationIdData as IConfigurationData[]}
        loading={isLoadingGetOrganizationConfigByOrganizationId}
        totalConfigurationCount={totalConfigurationCount}
      />
    </div>
  );
};

export default ConfigurationList;
